<template>
  <div :class="['btn',buttonType]" @click = "handleClick" :style="getButtonStyle">
    <span 
      v-if="(getIconPosition === 'right' || getIconPosition === 'bottom')"
      :class="[contentHasLimit ? 'overflowHidMultiLine' : '']"
      :style="colorStyle" v-html="getTextContent" 
      ref="btnInner">
    </span>
    <div v-if="getOptions.showIcon" style="text-align: center;" :class="getIconPosition === 'left' || getIconPosition === 'right' ? 'inline' : ''" >
      <cxIcon
        class="icon"
        v-if="getOptions.iconType !== 'img'"
        :options="getOptions"
        :iconStyle="getIconStyle"
      />
      <img
        class="icon"
        v-else-if="getOptions.iconType === 'img'"
        :src="getOptions.iconSrc"
        :style="getImgStyle"
      />
    </div>
    <span 
      v-if="(getIconPosition === 'left' || getIconPosition === 'top')"
      :class="[contentHasLimit ? 'overflowHidMultiLine' : '',]"
      :style="colorStyle" v-html="getTextContent" 
      ref="btnInner">
    </span>
  </div>
</template>
<script>
export default {
  name: "button",
  props: {
    myid: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    buttonType: {
      type: String,
      required: true
    }
  },
  computed: {
    getOptions() {
      return this.options[this.buttonType] || {}
    },
    contentHasLimit() {
      return this.getOptions && this.getOptions.contentHasLimit ? this.getOptions.contentHasLimit : false
    },
    getTextContent() {
      const defaultContent = this.buttonType === "resetButton" ? "重置" : "确定"
      console.log('defaultContent :>>',defaultContent);
      
      let content = this.getOptions && this.getOptions.content
        ? String(this.getOptions.content)
            ?.replace("&lt;&gt;", "<>")
            .replace(/(<br>)*$/g, "")
        : defaultContent
        console.log('content :>>',content);
        
      return this.contentHasLimit ? content?.substr(0, this.getOptions.textLimitLines) : content
    },
    iconSrc() {
      let iconSrc
      let iconSrcType = Number(this.getOptions.iconSrcType)
      switch (iconSrcType) {
        case 0:
          iconSrc = this.getOptions.iconSrc
          break
        case 1:
          iconSrc = this.getOptions.hoverIconSrc
          break
        case 2:
          iconSrc = this.getOptions.clickIconSrc
          break
        default:
          iconSrc = this.getOptions.iconSrc
      }
      return iconSrc && this.getOptions.showIcon !== false
    },
    iconType() {
      return this.getOptions.iconType ? this.getOptions.iconType : "img"
    },
    getIconPosition() {
      return this.getOptions.iconPosition ? this.getOptions.iconPosition : "left"
    },
    isColumn() {
      if (this.getIconPosition === "top" || this.getIconPosition === "bottom") return true
      else return false
    },
    getMargin() {
      return this.getOptions.iconPosition === "left"
        ? `0 ${this.getOptions.iconMargin}px 0 0`
        : this.getOptions.iconPosition === "right"
        ? `0 0 0 ${this.getOptions.iconMargin}px`
        : this.getOptions.iconPosition === "top"
        ? `0 0 ${this.getOptions.iconMargin}px 0`
        : `${this.getOptions.iconMargin}px 0 0 0`
    },
    getIconStyle() {
      const iconWidth = this.getOptions.hasOwnProperty('iconWidth') ? this.getOptions.iconWidth : 14
      return {
        display: "inline-block",
        verticalAlign: "middle",
        // "--color": this.getOptions.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.getOptions.iconColor && this.getOptions.iconColor.color
        //   ? this.getOptions.iconColor.color
        //   : this.getOptions.iconColor,
        "--color": this.$parseColor(this.getOptions.iconColor, {
          isThemeColor: this.getOptions.iconColorIsThemeColor
        }),
        fontSize: iconWidth + "px",
        width: iconWidth + "px",
        minWidth: iconWidth + "px",
        height: iconWidth + "px",
        margin: this.getMargin
      }
    },
    getImgStyle() {
      const iconWidth = this.getOptions.hasOwnProperty('iconWidth') ? this.getOptions.iconWidth : 14
      return {
        width: iconWidth + "px",
        height: iconWidth + "px",
        margin: this.getMargin
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    colorStyle() {
      let colorStyle = {}
      let colorArr = this.getOptions.colorArr || "{}"
      let tmp = []
      if (this.getOptions) {
        if (this.getOptions.textIsThemeColor) {
          colorStyle = {
            color: this.themeColor
          }
        } else {
          if ((JSON.parse(JSON.stringify(colorArr)) !== "{}")) {
            colorArr.data.stops.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            if (colorArr.label === "线性渐变") {
              colorStyle = {
                color: "transparent",
                // backgroundImage: `-webkit-linear-gradient(${colorArr.data.angle}deg, ${tmp.join(",")})`,
                backgroundImage: this.$parseColor(colorArr),
                "-webkit-background-clip": "text",
                "-webkit-line-clamp": this.getOptions.textLimitLines
              }
            } else if (colorArr.label === "颜色") {
              colorStyle = {
                // color: this.getOptions.textIsThemeColor ? this.themeColor : colorArr.data.stops[0][0],
                color: this.$parseColor(colorArr, {
                  isThemeColor: this.getOptions.textIsThemeColor
                }),
                "-webkit-line-clamp": this.getOptions.textLimitLines
              }
            }
          } else {
            colorStyle = {
              // color: this.getOptions.textIsThemeColor ? this.themeColor : this.getOptions.color,
              color: this.$parseColor(this.getOptions.color, {
                isThemeColor: this.getOptions.textIsThemeColor
              }),
              "-webkit-line-clamp": this.getOptions.textLimitLines
            }
          }
        }
        return colorStyle
      } else return null
    },
    buttonBgStyle() {
      const options = this.getOptions
        let containerBg = {
          backgroundImage: ""
        }
        let curBackground = options.background
        if (
          !curBackground ||
          !Array.isArray(curBackground) ||
          (Array.isArray(curBackground) && curBackground.length === 0)
        ) {
          curBackground = [
            {
              type: "color",
              label: "颜色",
              isThemeColor: options.hasOwnProperty("bgColorIsThemeColor") ? options.bgColorIsThemeColor : false,
              color: options.bgColor
            }
          ]
        }
        curBackground.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize = containerBg.backgroundSize
                ? `${containerBg.backgroundSize},${bg.clipSize}`
                : `${bg.clipSize}`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},${bg.alignType}`
                : `${bg.alignType}`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},${bg.repeatType}`
                : `${bg.repeatType}`
              break
            case "color":
              // containerBg.backgroundColor = bg.isThemeColor
              //   ? this.$store.state[this.request_prefix].page.themeColor
              //   : bg.color
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                // containerBg.backgroundImage +=
                //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition
                  ? `${containerBg.backgroundPosition},center`
                  : `center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat
                  ? `${containerBg.backgroundRepeat},no-repeat`
                  : `no-repeat`
              }
              break
            default:
          }
        })
        return containerBg
    },
    getButtonStyle() {
      const options = this.getOptions
        console.log('options :>>',options);
        let borderW = ""
        if (Array.isArray(options.borderWidth)) {
          options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${options.borderWidth}px`
        }
        let cursor
        if (this.request_prefix === "bigScreen" && this.isBigScreenPreview()) {
          cursor = options.cursorType ? options.cursorType : options.linkUrl ? "pointer" : "default"
        }
        let boxShadowStyle = ""
      if (Array.isArray(options.boxShadowH)) {
        options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            boxShadowStyle += ","
          }
          boxShadowStyle += `${options.boxShadowH[index]}px ${options.boxShadowV[index]}px ${options.boxShadowBlur[index]}px ${options.boxShadowSpread[index]}px ${this.$parseColor(options.boxShadowColor[index])}`
        })
      } else {
        boxShadowStyle += `${options.boxShadowH}px ${options.boxShadowV}px ${options.boxShadowBlur}px ${options.boxShadowSpread}px ${this.$parseColor(options.boxShadowColor)}`
      }
        let textShadowStyle = ""
        if (Array.isArray(options.textShadowH)) {
          options.textShadowH.forEach((item, index) => {
            if (index > 0) {
              textShadowStyle += ","
            }
            textShadowStyle += `${options.textShadowH[index]}px ${options.textShadowV[index]}px ${options.textShadowBlur[index]}px ${this.$parseColor(options.textShadowColor[index])}`
          })
        } else {
          textShadowStyle += `${options.textShadowH}px ${options.textShadowV}px ${options.textShadowBlur}px ${this.$parseColor(options.textShadowColor)}`
        }
        
        let padding = `${options.padding}px`
        if (options.paddingTypeFlag === 2) {
          padding = ` ${options.paddingTop}px  ${options.paddingRight}px  ${options.paddingBottom}px  ${options.paddingLeft}px`
        }

        let thisStyle = {
          "line-height":
            options.lineHeightType === "%" ? options.lineHeight / 100 : options.lineHeight + "px",
          "letter-spacing":
            options.letterSpacingType === "%"
              ? options.letterSpacing / 100 + "em"
              : options.letterSpacing + "px",
          "text-indent":
            options.letterSpacingType === "%"
              ? options.letterSpacing / 100 + "em"
              : options.letterSpacing + "px",
          "font-style": options.fontStyle,
          "font-family": options.fontFamily,
          opacity: options.opacity,
          // color: options.textIsThemeColor ? this.themeColor : options.color,
          color: this.$parseColor(options.color, {
            isThemeColor: options.textIsThemeColor
          }),
          "font-size": (options.hasOwnProperty("fontSize") ? options.fontSize : 14) + "px",
          "font-weight": options.fontWeight,
          "text-decoration": options.textDecoration,
          "text-align": options.textAlign || "center",
          "border-style": options.borderStyle || (parseInt(borderW) && "solid"),
          // "border-color": options.borderIsThemeColor
          //   ? this.themeColor
          //   : options.borderColor && options.borderColor.color
          //   ? options.borderColor.color
          //   : options.borderColor,
          "border-color": this.$parseColor(options.borderColor, {
            isThemeColor: options.borderIsThemeColor
          }),
          "border-width": options.showBorder !== false ? borderW : 0,
          "box-shadow": boxShadowStyle,
          "text-shadow": textShadowStyle,
          "border-top-left-radius":
            options.shapeType == "round"
              ? options.borderTopLeftRadius
              : options.borderTopLeftRadius + "px",
          "border-top-right-radius":
            options.shapeType == "round"
              ? options.borderTopLeftRadius
              : options.borderTopRightRadius + "px",
          "border-bottom-left-radius":
            options.shapeType == "round"
              ? options.borderTopLeftRadius
              : options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius":
            options.shapeType == "round"
              ? options.borderTopLeftRadius
              : options.borderBottomRightRadius + "px",
          cursor: cursor,
          padding: padding
        }
        let marginLeft,
          marginTop,
          transformLeft = `${options.left || 0}px`,
          transformTop = `${options.top || 0}px`
        if (options.leftType === "%") {
          let offsetLeft = options.offset ? options.offset[1] - options.offset[3] : 0
          marginLeft = `calc(${options.left}% - ${offsetLeft}px)`
          transformLeft = options.margin ? options.margin[3] : "0px"
        }
        if (options.topType === "%") {
          let offsetTop = options.offset ? options.offset[2] - options.offset[0] : 0
          marginTop = `calc(${options.top}% - ${offsetTop}px)`
          transformTop = options.margin ? options.margin[0] : "0px"
        }
        
        let transform = `translate(${transformLeft}, ${transformTop})`
        return {
          marginLeft: marginLeft,
          transform: transform,
          top: marginTop,
          // left: `${options.left}${options.leftType === "%" ? "%" : "px"}`,
          // top: `${options.top}${options.topType === "%" ? "%" : "px"}`,
          width: `${options.width}${options.widthType === "%" ? "%" : "px"}`,
          height: `${options.height}${options.heightType === "%" ? "%" : "px"}`,
          ...this.buttonBgStyle,
          ...thisStyle
        }
    },
  },
  methods: {
    handleClick(){
      this.$emit("handleClick")
    }
  }
}
</script>
<style scoped>
.inline {
  display: inline-block;
  line-height: 1;
}
</style>